var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.phoneNumber)?_c('span',{staticClass:"icon-flag",class:_vm.classes},[(_vm.setSelectedFlag)?_c('img',{attrs:{"src":_vm.setSelectedFlag.url,"alt":_vm.setSelectedFlag.name}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }